/* eslint-disable camelcase */
import { pruneEmpty } from 'saddlebag-grappler';

export const getAdditionalServiceInfo = (webNode) =>
  pruneEmpty({
    web_node: webNode,
  });

export const getURLTrackingParams = (params = {}) => {
  const {
    _ga,
    gclid,
    ksh_id,
    utm_campaign,
    utm_content,
    utm_id,
    utm_keyword,
    utm_medium,
    utm_name,
    utm_source,
    utm_term,
    yclid,
  } = params;
  return pruneEmpty({
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    utm_term,
    utm_id,
    utm_name,
    utm_keyword,
    ksh_id,
    gclid,
    yclid,
    _ga,
  });
};
